import script from "./upload-Img.vue?vue&type=script&setup=true&lang=js"
export * from "./upload-Img.vue?vue&type=script&setup=true&lang=js"

import "./upload-Img.vue?vue&type=style&index=0&id=b92da19e&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b92da19e"]])

export default __exports__